"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleArrayValue = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
/**
 * Helper for removing an item from an array if it exists, or adding it if it doesn't exist.
 */
var toggleArrayValue = function toggleArrayValue(values, value) {
  var index = values.indexOf(value);
  var nextValues = (0, _toConsumableArray2.default)(values);
  if (index >= 0) {
    nextValues.splice(index, 1);
  } else {
    nextValues.push(value);
  }
  return nextValues;
};
exports.toggleArrayValue = toggleArrayValue;